import { render, staticRenderFns } from "./FormQuill.vue?vue&type=template&id=4ecb7d1e"
import script from "./FormQuill.vue?vue&type=script&lang=js"
export * from "./FormQuill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports